window._bolt_data_object = window._bolt_data_object || {}; // global variable for context data
(function() {
  var context_data = null;
  var c = {
    init: function() {
      document.addEventListener('bolt-init', function() {
        c.loadSections();
      });
      if ( !!document.getElementById('bolt-website') ) {
        c.initBoltInteractions();
        c.initContextData();
        c.initDebugLinks();
      }
    },
    initDebugLinks: function() {
      const debugLinks = document.querySelectorAll('.bolt-debug-info-link');
      debugLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.stopPropagation();
          c.toggleDebugInfo(link);
        });
      });
    },
    toggleDebugInfo: function(link){
      const content = link.nextElementSibling;
      content.style.display = content.style.display === 'block' ? 'none' : 'block';
    },
    regenerateLink: function(section) {
      section.querySelector('.bolt-regenerate-link').style.display = 'none';
      c.loadSection(section, true);
    },
    initContextData: function() {
      context_data = window._bolt_data_object;
      var contextDataElements = document.querySelectorAll('.bolt-context-data');
      contextDataElements.forEach(function(element) {
        var id = element.getAttribute('data-id');
        context_data[id] = element.innerText || element.value;
      });
    },
    initBoltInteractions: function() {
      const bolt = document.getElementById('right-bolt');
      const toggle = bolt.querySelector('.bolt-toggle');
      const icon = toggle.querySelector('.material-icons');

      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        bolt.classList.toggle('expanded');
        icon.textContent = bolt.classList.contains('expanded') ?
          'keyboard_arrow_right' : 'bolt';
      });

      let hasBeenExpanded = false;

      bolt.addEventListener('transitionend', function() {
        if (bolt.classList.contains('expanded') && !hasBeenExpanded) {
          hasBeenExpanded = true;
          const event = new Event('bolt-init');
          document.dispatchEvent(event);
        }
      });

      bolt.addEventListener('click', function(e) {
        e.stopPropagation();
      });

      document.addEventListener('click', function() {
        if (bolt.classList.contains('expanded')) {
          bolt.classList.remove('expanded');
          icon.textContent = 'bolt';
        }
      });
    },
    loadSections: function() {
      var sections = document.querySelectorAll('.bolt-section[data-bolt-prompt]');
      sections.forEach(function(section) {
        c.loadSection(section);
        c.initRegenerateLink(section);
      });
    },
    initRegenerateLink: function(section) {
      const regenerateLink = section.querySelector('.bolt-regenerate-link');
      regenerateLink.addEventListener('click', function() {
        c.regenerateLink(section);
      });
    },
    loadSection: function(section, regenerate=false) {
      var boltPrompt = section.getAttribute('data-bolt-prompt');
      var website = document.getElementById('bolt-website').value;
      var page = document.getElementById('bolt-page').value;
      var contentSection = section.querySelector('.bolt-section-content');
      //contentSection.innerHTML = '<div class="spinner"><div class="spinner-inner"></div></div>';
      contentSection.classList.add('loading-section');

      // remove meta info from Charts
      if (context_data['offer-impressions']) {
        context_data['offer-impressions'].offer_impressions.forEach(function(elem){
          delete elem._meta;
        });
      }
      let debug_prompt = "";
      if (section.querySelector('.bolt-debug-info-content')) {
        debug_prompt = section.querySelector('.bolt-debug-info-content').value;
      }
      $.ajax({
        url: '/bolt/content',
        method: 'POST',
        data: {
          website: website,
          page: page,
          prompt: boltPrompt,
          context_data: context_data,
          regenerate: regenerate,
          debug_prompt: debug_prompt
        },
        success: function(response) {
          if (response && (typeof response.html === 'string')) {
            contentSection.innerHTML = response.html;
            contentSection.classList.remove('loading-section');
            section.querySelector('.bolt-regenerate-link').style.display = 'block';
            if (response.debug_info) {
              section.querySelector('.request-id').textContent = response.request_id;
              section.querySelector('.bolt-debug-info-content').value = response.debug_info;
            }
          } else {
            // still waiting for response from LLM
            setTimeout(function() {
              c.loadSection(section);
            }, 1000);
          }
        },
        error: function(xhr, status, error) {
          console.error('Error loading section:', error);
        }
      });
    }
  };
  c.init();
})();
